import React, { useEffect, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, GetLoginCredentialDb, linksUrl } from "../constants/enum.js"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setReload } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { resetFilter } from "../state/ledgerSlice.jsx"
import { resetGrayFilter } from "../state/grayStockSlice.jsx"
import { Button } from "@nextui-org/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"
import MyComponent from "../components/MyComponent.jsx"

const Companies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user, userSetting } = useSelector((state) => state.auth)
  const { yearId, compCode } = useSelector((state) => state.company)
  const [compData, setCompData] = useState([])
  const [selectedKey, setSelectedKey] = useState(new Set());
  const queryClient = useQueryClient()

  // const {
  //   isPending,
  //   isError,
  //   data: compData = [],
  //   mutate: funLoadData
  // } = usePostLogin({
  //   url: apiRoute.company,
  //   queryKey: "Company",

  // })
  // const {
  //   isLoading,
  //   data: acyearData = [],
  // } = useFetchWithBody({
  //   url: apiRoute.companyAcYear,
  //   queryKey: "CompanyAcyear"
  // })
  const { data: userCompMapData = [], } = useFetchWithBody({
    url: apiRoute.userCompMaping.getUserMaping,
    queryKey: "getUsermaping",
    inputData: {
      userid: user.userid
    },
  })

  const {
    isPending,
    isError,
    data = [],
    mutate: funSetYearId
  } = usePost({
    url: apiRoute.setAcYearId,
    queryKey: "SetCompanyData",
    onSuccessTasks: (data) => {
      if (userCompMapData && userCompMapData.length > 0) {

        const selComp = userCompMapData.map(ele => String(ele.COMPCODE));
        const selCompData = data.filter((ele) => selComp.includes(String(ele.COMPCODE)))
        setCompData(selCompData)
      }
      else {
        setCompData(data)
      }
    }

  })

  useEffect(() => {

    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: ''
      }
    })

  }, [])

  const onSuccessTasks = (data) => {
    if (data && data?.length > 0) {
      dispatch(setAppType(data[0]?.AppType))
    }

  }
  const {
    isError: isErrorType,
    data: modData = [],
    mutate: getApptype
  } = usePostLogin({
    url: apiRoute.modeSetting.getAppType,
    queryKey: "ModAppType",
    onSuccessTasks

  })

  const INITIAL_VISIBLE_COLUMNS = ["COMPNAME"]

  const columns = [{ name: "COMPNAME", uid: "COMPNAME", sortable: true, align: COLUMN_ALIGN_TYPE.left }]
  
  const handleSelectionChange = (payload) => {


    const { e } = payload;

    // 🔥 CASE 1: Select all
    if (e === "all") {
      const allKeys = compData.map((row) => String(row.COMPCODE));
      setSelectedKey(new Set(allKeys));
      return;
    }

    // 🔥 CASE 2: empty selection
    if (!e) {
      setSelectedKey(new Set());
      return;
    }

    // 🔥 CASE 3: if Set
    if (e instanceof Set) {
      setSelectedKey(e);
      return;
    }

    // 🔥 CASE 4: array
    if (Array.isArray(e)) {
      setSelectedKey(new Set(e));
      return;
    }

    // 🔥 CASE 5: fallback (single value or object)
    if (typeof e === "string" || typeof e === "number") {
      setSelectedKey(new Set([e]));
      return;
    }

    console.warn("Unknown selection format:", e);

  };
  const topActionBtn = [
    {
      label: "Connect",
      icon: <FontAwesomeIcon icon={faPlus} />,
      isShowOnSelection: true,
      type: TOP_ACTION_BTN_TYPE.link,
      onClick: ({ selectedKeys }) => {
        let selectedCompCode = []
        let selectedCompName = []
        if (selectedKeys !== "all") {
          selectedKeys.forEach((value) => {
            selectedCompCode.push(value)
            //get selected compname
            let filterData = compData.filter((ele) => ele.COMPCODE == value)
            if (filterData && filterData.length > 0) selectedCompName.push(filterData[0].COMPNAME)
          })
        } else {
          compData.map((item) => selectedCompCode.push(item.COMPCODE))
        }
        toast.success("Conntected", {
          position: "top-center",
          autoClose: 1000,
        })

        //get selected company name 
        const intSelCompCode = selectedCompCode.map(value => parseInt(value, 10));
        const selData = compData.filter((ele) => intSelCompCode.includes(ele.COMPCODE))
        dispatch(setCompCode({ compCode: selectedCompCode, compName: selectedCompName }))
        // const filSelCompData=compData.fil
        // if (yearId == selData[0]?.YEAR_ID) {
        dispatch(setCompInfo({
          yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
          state: selData[0]?.STATE, groupCode: selData[0].CGCODE
          , address: selData[0]?.COMP_ADDRESS
          , panNo: selData[0]?.IT_NO || ''
          , gstNo: selData[0]?.GST_NO || ''
          , objComp: selData
          //,objYear:[]]
        }))
        // }
        dispatch(resetFilter())//reset year company wise
        dispatch(resetGrayFilter())
        //dispatch(setReload(true))
        //get apptype from module setting
        getApptype({
          data: {
            db_user: GetLoginCredentialDb(user, compData[0]?.YEAR_ID)
          }
        })

        let startup_page = linksUrl.dashboard.tradingDashboard
        //set start up page user setting wise
        if (userSetting && userSetting.length > 0) {
          const filterData = userSetting.filter((ele) => ele.parameter == ENUM_USERSETING_PARAMS.StartUp && ele.setting_visible == 1)

          if (filterData && filterData.length > 0) {
            if (filterData.filter((ele) => ele.setting_value == ENUM_USERSETING_SETVALUE.TextileCostFinance).length > 0)
              startup_page = linksUrl.dashboard.masterDashboard
          }
        }

        navigate(startup_page)
      },
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }
  const handleOnclick = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  // if (isError) {
  //   return <ErrorCard />
  // }

  return (
    <div>
      <MainContainer pageName="Company" info={[]} breadcrumbs={["Home", "Company"]}>
        {/* <MyComponent items={items}  /> */}


        {isError ? <div className="bg-yellow-200 px-6 py-4 my-4 text-amber-700 rounded-md text-md flex gap-4  items-center mx-auto max-w-lg">Something went wrong !
          <Button onPress={handleOnclick()} variant="light" style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click here to Reconnect</Button> </div> :
          <NextUITable
            INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
            data={compData}
            columns={columns}
            exportColumns={columns}
            topActionBtn={topActionBtn}
            downloadFileName="Company"
            id="COMPCODE"
            rowSelection={true}
            showAdvanceFilter={false}
            handleSelectionChange={handleSelectionChange}
            selectedKeys={selectedKey}
            setSelectedKeys={setSelectedKey}

          />
        }
      </MainContainer>

    </div>
  )
}

export default Companies
